export const TitleWithDivider = ({ titleText, useDivider }) => (
  <div>
    <div className="mayo-title-text">{titleText}</div>
    {useDivider === true ? <div className="divider mt-5"></div> : ""}
  </div>
);
